module.exports = __webpack_public_path__ + "static/media/navigation_flow-latest.865f822a.jpg";